<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑上架模组"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="模组厂商">
          <a-select
            v-decorator="['module_producer_id', {
              rules: [{ required: true, message: '请选择模组厂商' }]
            }]"
            show-search
            option-filter-prop="children"
            placeholder="请选择"
            :loading="loadingProducerOptions"
            @change="handleProducerChange"
          >
            <a-select-option
              v-for="opt in producerOptions"
              :key="opt.id"
              :value="opt.id"
            >
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="模组型号">
          <a-select
            v-decorator="['module_model_id', {
              rules: [{ required: true, message: '请选择模组型号' }]
            }]"
            show-search
            option-filter-prop="children"
            placeholder="请先选择模组厂商"
            :loading="loadingModelOptions"
          >
            <a-select-option
              v-for="opt in modelOptions"
              :key="opt.id"
              :value="opt.id"
            >
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="单价(元/片)">
          <a-input-number
            style="width: 100%"
            :min="0"
            :precision="2"
            :step="0.01"
            v-decorator="['unit_price', {
              rules: [{ required: true, message: '请输入单价' }]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findBaseModuleProductForm, updateBaseModuleProduct } from '@/api/base_module_product'

export default {
  name: 'EditBaseModuleProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'base_module_product_edit' }),
      submitting: false,
      producerOptions: [],
      modelOptions: [],
      loadingProducerOptions: false,
      loadingModelOptions: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchProducerOptions().then(() => {
      this.fetchFormData()
    })
  },
  methods: {
    fetchProducerOptions() {
      this.loadingProducerOptions = true
      return findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data
        }
        this.loadingProducerOptions = false
      })
    },

    fetchModelOptions(producerId) {
      this.loadingModelOptions = true
      return findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
        this.loadingModelOptions = false
      })
    },

    fetchFormData() {
      findBaseModuleProductForm(this.id).then((res) => {
        if (res.code === 0) {
          const data = res.data
          this.fetchModelOptions(data.module_producer_id).then(() => {
            this.form.setFieldsValue(data)
          })
        }
      })
    },

    handleProducerChange(producerId) {
      this.form.setFieldsValue({ module_model_id: undefined })
      this.modelOptions = []
      if (producerId) {
        this.fetchModelOptions(producerId)
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateBaseModuleProduct(this.id, values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
